// extracted by mini-css-extract-plugin
export default {"container":"AboutInfluio_container__lKGJI","icons":"AboutInfluio_icons__kHc2X"};